import classNames from 'classnames'
import commonStyles from '../shared/styles.module.css'
import styles from './UserInfo.module.css'
import { LoadingSkeleton } from '../../components/LoadingSkeleton'

function UserInfoLoading() {
  return (
    <div className={classNames(styles.trigger, styles.login, commonStyles.navigationLink)}>
      <LoadingSkeleton className={styles.image} width="40px" height="40px" borderRadius="100%" />
      <LoadingSkeleton className={styles.label} height="28px" width="164px" />
    </div>
  )
}
export default UserInfoLoading
